import { useQuery } from 'react-query'
import { FetchProductionParams, PanelDataParams } from './EditProduction.types'
import { request } from 'Features/auth/axios-client'

const fetchProduction = async ({
  planId,
  sourcesiteId,
  workcentreId,
}: FetchProductionParams) => {
  const data = await request({
    url: `/plan/${planId}/source-sites/${sourcesiteId}/workcentres/${workcentreId}/edit-production`,
  })
  return data
}

export const useProduction = (params: FetchProductionParams) => {
  return useQuery(
    ['production', params.planId, params.sourcesiteId, params.workcentreId],
    () => fetchProduction(params),
    {
      refetchOnMount: false,
      select: ({ data }) => data,
      refetchOnWindowFocus: false,
    }
  )
}

const fetchPanelData = async ({ planId, workcentreId }: PanelDataParams) => {
  const data = await request({
    url: `/plan/${planId}/sku/sku-code/workcentre/${workcentreId}/panel-data`,
  })
  return data
}

export const usePanelData = (params: PanelDataParams) => {
  return useQuery(
    ['panel-data', params.planId, params.workcentreId],
    () => fetchPanelData(params),
    {
      refetchOnMount: false,
      select: ({ data }) => data?.data?.result,
      refetchOnWindowFocus: false,
    }
  )
}
